module.exports = __webpack_public_path__ + "static/media/gifFour.5128a406.gif";